// @flow
import hasPermission from '../globalFunctions/hasPermission';

export default {
  path: '/',
  component: () => import('../modules/DeParaFaturamento/Index.vue'),
  children: [
    {
      path: '/de-para-faturamento',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'SIGTIM',
            name: 'Sigtim'
          },
          {
            text: 'DE-PARA Faturamento',
            name: 'DeParaFaturamento'
          }
        ]
      },
      name: 'DeParaFaturamento',
      component: () => import('../modules/DeParaFaturamento/DeParaFaturamento.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.sigtim.de_para')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: '/criar-relacao-distribuidores',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'DE-PARA Faturamento',
            name: 'DeParaFaturamento'
          },
          {
            text: 'Criar Relação de Distribuidores',
            name: 'criarRelacaoDistribuidores'
          }
        ]
      },
      name: 'criarRelacaoDistribuidores',
      component: () => import('../modules/DeParaFaturamento/CreateDistributorsRelations.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.sigtim.de_para')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: '/criar-relacao-distribuidores/:id',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'DE-PARA Faturamento',
            name: 'DeParaFaturamento'
          },
          {
            text: 'Editar Relação de Distribuidores',
            name: 'criarRelacaoDistribuidores'
          }
        ]
      },
      name: 'EditarRelacaoDistribuidores',
      component: () => import('../modules/DeParaFaturamento/EditDistributorsRelation.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.sigtim.de_para')) {
          next();
        } else {
          next('/');
        }
      }
    }
  ]
};
